import axiosInstance from '../../config/axios.config';
import { success } from './loader.action';
import { downloadFile } from '../../utils/downloadFile';
import { convertMillisecondsToDate } from '../../utils/convertToDate';
import { handleRequestError } from '../../utils/handleRequestError';

//функция для получения отчета с сервера
export const getContractReportFromServer = (payload, divisionName) => async (dispatch) => {
  try {
    // Определяем URL на основе переданного параметра
    const url = payload?.urlPath ? `/api/reports/${payload.urlPath}` : '/api/reports';
    // Отправляем POST запрос с указанием, что ответ будет в формате blob
    const response = await axiosInstance.post(url, payload, { responseType: 'blob' });

    const period = `${convertMillisecondsToDate(payload?.startDate, false)} - ${convertMillisecondsToDate(
      payload?.endDate,
      false
    )}`;

    let filename = undefined;
    switch (payload?.reportType) {
      case 'onOff':
        filename = `Включение_выключение ${period}.docx`;
        break;
      case 'onOff10':
        filename = `Включение_выключение - 10 мин ${period}.docx`;
        break;
      case 'conn':
        filename = `Подключение_отключение ${period}.xlsx`;
        break;
      case 'restrict':
        filename = `Ограждение ${period}.xlsx`;
        break;
      case 'summary':
        filename = `Сводный отчет за период ${period}.docx`;
        break;
      case 'detailed':
        filename = `Детализированный отчет за период ${period}.docx`;
        break;
      case 'service':
        filename = `Отчет об оказанных услугах по ${divisionName} за период ${period}.docx`;
        break;
      case 'serviceXlsx':
        filename = `Отчет об оказанных услугах по ${divisionName} за период ${period}.xlsx`;
        break;
      case 'general':
        filename = `Общий отчет за период ${period}.xlsx`;
        break;
      default:
        filename = `Отчет за период ${period}.docx`;
    }

    const { data } = response;

    if (data) {
      // Если данные существуют, сигнализируем об успехе и инициируем скачивание файла
      dispatch(success());
      downloadFile(data, filename);
    }
  } catch (error) {
    // В случае ошибки передаем её в функцию обработки
    handleRequestError(error, dispatch);
  }
};


